import type { BucketRow } from '../types/traffic'

/** The product area with the most blocked requests, or null when unknown. */
export function topSection(sections: BucketRow[]): BucketRow | null {
  return sections.length > 0 ? sections[0] : null
}

/** 0–1 as a whole percentage, e.g. 0.184 → '18%'. */
export function formatPercent(value: number): string {
  return `${Math.round(value * 100)}%`
}
